// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media print {\n  ._31a4EzIoi7aFgj {\n    color: #172b4d;\n  }\n  ._18-SofjJ-MBcY_ svg {\n    color: #172b4d;\n  }\n}\n._10A11gjLNdEncG {\n  max-width: 400px;\n  overflow: hidden;\n  padding-left: 8px;\n  text-decoration: none;\n  text-overflow: ellipsis;\n  background-color: #FFFFFF;\n  color: #000000;\n  margin-bottom: 0px;\n}\n._10A11gjLNdEncG:hover {\n  background-color: rgba(255, 255, 255, 0.9);\n}\n._10A11gjLNdEncG._2UJa4AZqB-yz-L {\n  background-color: #0079BF;\n  color: #FFFFFF;\n}\n._10A11gjLNdEncG._2UJa4AZqB-yz-L:hover {\n  color: #FFFFFF;\n  background-color: #026AA7;\n}\n._31a4EzIoi7aFgj {\n  margin-left: 4px;\n}\n._18-SofjJ-MBcY_ {\n  position: relative;\n  top: 1px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardShareButtonText": "_31a4EzIoi7aFgj",
	"boardShareButtonIcon": "_18-SofjJ-MBcY_",
	"boardShareButton": "_10A11gjLNdEncG",
	"lightBackground": "_2UJa4AZqB-yz-L"
};
export default ___CSS_LOADER_EXPORT___;
